import { STATUS } from '../../constants';

const toCount = (value) => {
	const parsed = Number(value);
	return Number.isFinite(parsed) && parsed > 0 ? parsed : 0;
};

export const isStockDeliveryItemDelivered = (item) => {
	return Boolean(item?.deliveredAt || item?.receivedAt);
};

export const getStockDeliveryProgress = (stockDelivery) => {
	const items = Array.isArray(stockDelivery?.items) ? stockDelivery.items : null;
	if (items) {
		const totals = items.reduce((acc, item) => {
			if (!item) {
				return acc;
			}

			acc.itemCount += 1;
			if (isStockDeliveryItemDelivered(item)) {
				acc.deliveredItemCount += 1;
			}
			if (item.receivedAt) {
				acc.stockedItemCount += 1;
			}
			return acc;
		}, {
			itemCount: 0,
			deliveredItemCount: 0,
			stockedItemCount: 0,
		});

		return {
			...totals,
			hasItems: totals.itemCount > 0,
			allDelivered: totals.itemCount > 0 && totals.deliveredItemCount === totals.itemCount,
			allStocked: totals.itemCount > 0 && totals.stockedItemCount === totals.itemCount,
		};
	}

	const itemCount = toCount(stockDelivery?.itemCount);
	const deliveredItemCount = toCount(stockDelivery?.deliveredItemCount);
	const stockedItemCount = toCount(stockDelivery?.stockedItemCount);

	return {
		itemCount,
		deliveredItemCount,
		stockedItemCount,
		hasItems: itemCount > 0,
		allDelivered: itemCount > 0 && deliveredItemCount >= itemCount,
		allStocked: itemCount > 0 && stockedItemCount >= itemCount,
	};
};

export const getStockDeliveryDisplayStatus = (stockDelivery) => {
	const status = stockDelivery?.status;
	if (status === STATUS.COMPLETE) {
		const { hasItems, allStocked } = getStockDeliveryProgress(stockDelivery);
		if (hasItems && !allStocked) {
			return {
				status: STATUS.IN_PROGRESS,
				text: 'Pending stock',
				isPendingStock: true,
			};
		}

		return {
			status: STATUS.COMPLETE,
			text: 'Delivered',
			isPendingStock: false,
		};
	}

	if (status === STATUS.IN_PROGRESS) {
		return {
			status: STATUS.IN_PROGRESS,
			text: 'Partially delivered',
			isPendingStock: false,
		};
	}

	return {
		status: STATUS.PENDING,
		text: 'Pending delivery',
		isPendingStock: false,
	};
};
